import React from 'react';
import PropTypes from 'prop-types';

import useDispatch from 'client/hooks/useDispatch';
import PmsIntegrationPromptActions from 'client/actions/PmsIntegrationPrompt';

import SrButton, {
  SR_BUTTON_HEIGHT_SHORT,
  SR_BUTTON_THEME_ADOBE_GREEN,
} from 'client/components/SrButton/SrButton';

import './UPBuildiumSyncPrompt.less';

const UPBuildiumSyncPrompt = ({ utilityPartner, onClose, onShowSyncSteps }) => {
  const dispatch = useDispatch();

  const onDismiss = () => {
    dispatch(PmsIntegrationPromptActions.trackPrompt, {
      utilityPartnerId: utilityPartner.id,
    });

    onClose();
  };

  return (
    <div styleName="page">
      <div styleName="skip">
        <span onClick={onDismiss}>Skip for now</span>
        <div styleName="x" onClick={onDismiss} />
      </div>
      <div styleName="content">
        <img styleName="icon" src="/images/buildium-logo.png" alt="Buildium Logo" />
        <span styleName="title">✨ New Buildium Integration on Utility Profit</span>
        <span styleName="headline">Sync your Buildium to increase completed utility setups.</span>
        <span styleName="details">✅ 600+ PMs sync to Utility Profit.</span>
        <SrButton
          width="200px"
          margin="0 0 7px"
          theme={SR_BUTTON_THEME_ADOBE_GREEN}
          heightType={SR_BUTTON_HEIGHT_SHORT}
          hasBoxShadow
          onClick={onShowSyncSteps}
          themeOverrides={{
            fontSize: '16px',
            padding: '0px 15px 2px',
          }}
        >
          Start Buildium Sync
        </SrButton>
        <span styleName="footnote">5-minute Set Up</span>
      </div>
    </div>
  );
};

UPBuildiumSyncPrompt.propTypes = {
  utilityPartner: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onShowSyncSteps: PropTypes.func.isRequired,
};

UPBuildiumSyncPrompt.displayName = 'UPBuildiumSyncPrompt';

export default UPBuildiumSyncPrompt;
